import { render } from "./spain.svg?vue&type=template&id=632cd168"
const script = {}
script.render = render

export default script